import React, {useState, useEffect} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {Redirect} from 'react-router-dom';

const withErrorHandler = (WrappedComponent, axios) => {
    return (props) => {
        const [error, setError] = useState(null);

        useEffect(() => {
            const reqInterceptor = axios.interceptors.request.use(req => {
                setError(null);
                return req;
            });
            const resInterceptor = axios.interceptors.response.use(
                res => res,
                err => {
                    if (err.response && err.response.status !== 405) {
                        setError(err);
                    }
                    return Promise.reject(err);
                }
            );

            return () => {
                axios.interceptors.request.eject(reqInterceptor);
                axios.interceptors.response.eject(resInterceptor);
            };
        }, [axios.interceptors.request, axios.interceptors.response]);

        const errorConfirmedHandler = () => {
            setError(null);
        };

        let errorModal = null;

        if (error) {
            if (error.response && error.response.status === 404) {
                return <Redirect from="/projekte/:id" to="/wie-gehts-weiter"/>;
            }

            const errorMessage =
                error.response && error.response.data
                    ? error.response.data
                    : error.message || 'Ein unbekannter Fehler ist aufgetreten';

            const errorTitle = error.response?.status
                ? `Fehler: ${error.response.status}`
                : 'Ein Fehler ist aufgetreten';

            errorModal = (
                <Modal
                    isOpen={!!error}
                    toggle={errorConfirmedHandler}
                    centered
                    aria-labelledby="error-modal-title"
                    keyboard
                >
                    <ModalHeader toggle={errorConfirmedHandler} id="error-modal-title">
                        {errorTitle}
                    </ModalHeader>
                    <ModalBody>
                        <div id="error-modal-description">
                            {typeof errorMessage === 'string' && errorMessage.includes('<') ? (
                                <div dangerouslySetInnerHTML={{__html: errorMessage}}/>
                            ) : (
                                <p>{String(errorMessage)}</p>
                            )}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={errorConfirmedHandler}>
                            Schließen
                        </Button>
                    </ModalFooter>
                </Modal>
            );
        }

        return (
            <>
                {errorModal}
                <WrappedComponent {...props} />
            </>
        );
    };
};

export default withErrorHandler;